import clsx from 'clsx';
import ContentBlock from './ContentBlock';
import VideoEmbed from './VideoEmbed';

/**
 * A subcomponent of VideoWayfinder that contains the main bulk of the section--
 * a video and a content block with a title, content, and optional link.
 */
const InnerSection = ({
  videoFirst,
  vimeoUrl,
  youtubeUrl,
  portraitVideo,
  backgroundColor,
  blockColor,
  title,
  content,
  link,
  position
}) => {
  const videoAlignmentClasses = getVideoAlignmentClasses(
    videoFirst,
    portraitVideo
  );
  const videoInfo = getVideoInfo(vimeoUrl, youtubeUrl);

  return (
    <div
      className={clsx(
        'relative py-10',
        portraitVideo ? 'sm:pt-[324px] sm:pb-15 lg:py-[120px]' : 'sm:py-15',
        backgroundColor ? `bg-[${backgroundColor}]` : 'bg-white'
      )}
    >
      <div
        className={clsx(
          'relative flex w-full sm:absolute sm:max-w-full lg:top-0 lg:bottom-0 lg:w-max lg:max-w-1/2',
          portraitVideo ? 'sm:top-15' : 'm-auto justify-center sm:top-2',
          videoAlignmentClasses
        )}
      >
        {videoInfo && (
          <VideoEmbed
            url={videoInfo.url}
            portraitVideo={portraitVideo}
            type={videoInfo.type}
            title={title}
          />
        )}
      </div>
      <div
        className={clsx(
          `lg:flex`,
          { 'pt-5 sm:pt-0': portraitVideo },
          videoFirst ? 'lg:flex-row-reverse' : 'lg:flex-row',
          { 'lg:pl-15': portraitVideo && !videoFirst }
        )}
      >
        <div className={portraitVideo ? 'lg:max-w-3/4' : 'lg:max-w-[65%]'}>
          <ContentBlock
            blockColor={blockColor}
            videoFirst={videoFirst}
            portraitVideo={portraitVideo}
            title={title}
            content={content}
            link={link}
            position={position}
          />
        </div>
      </div>
    </div>
  );
};

/**
 * Returns video information into {type, url}. Might look weird to use a
 * function conditional here but it's way easier to read than a nested ternary.
 */
const getVideoInfo = (vimeoUrl, youtubeUrl) => {
  if (vimeoUrl) return { type: 'vimeo', url: vimeoUrl };
  if (youtubeUrl) return { type: 'youtube', url: youtubeUrl };
  return null;
};

/**
 * Helper function to manage video alignment classes.
 */
const getVideoAlignmentClasses = (videoFirst, portraitVideo) => {
  if (portraitVideo) {
    return videoFirst ? 'lg:left-15' : 'lg:right-15';
  }
  return videoFirst ? 'lg:left-0' : 'lg:right-0';
};

export default InnerSection;
